module.exports = __webpack_public_path__ + "static/img/Patrick_Cripps_mobile.858c97d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Patrick_Cripps_mobile.jpg
// module id = sLJu
// module chunks = 0